import React, { useContext } from 'react';
import { NavLink, useHistory } from 'react-router-dom';
import routes from '../router/routes';
import { Button, Divider, Dropdown } from 'antd';
import ThemedButton from './ThemedButton';
import { MenuOutlined } from '@ant-design/icons';
import { InfoCircleOutlined as InfoIcon } from '@ant-design/icons';
import { InfoModalContext } from '../context/InfoModalContext';


const NavTabs = ({ activeUrl, dividerType = 'vertical' }) => (
  <div className="nav-tabs">
    <div className={`nav-item ${activeUrl === routes.QUIZ && 'active'}`}>
      <NavLink to={routes.QUIZ} isActive={() => activeUrl === routes.QUIZ}>WASP-A</NavLink>
    </div>
    <Divider type={dividerType} className='nav-divider' />
    <div className={`nav-item ${activeUrl === routes.WASP_P && 'active'}`}>
      <NavLink to={routes.WASP_P} isActive={() => activeUrl === routes.WASP_P}>WASP-P</NavLink>
    </div>
    <Divider type={dividerType} className='nav-divider' />
    <div className={`nav-item ${activeUrl === routes.ABOUT && 'active'}`}>
      <NavLink to={routes.ABOUT} isActive={() => activeUrl === routes.ABOUT}>Project</NavLink>
    </div>
    <Divider type={dividerType} className='nav-divider' />
    <div className={`nav-item ${activeUrl === routes.TEAM && 'active'}`}>
      <NavLink to={routes.TEAM} isActive={() => activeUrl === routes.TEAM}>Team</NavLink>
    </div>
    <Divider type={dividerType} className='nav-divider' />
    <div className={`nav-item ${activeUrl === routes.CONTACT && 'active'}`}>
      <NavLink to={routes.CONTACT} isActive={() => activeUrl === routes.CONTACT}>Contact</NavLink>
    </div>
  </div>
)

const NavTabsOverlay = ({ url }) => (
  <div className="nav-tabs-overlay">
    <NavTabs activeUrl={url} dividerType='horizontal' />
  </div>
)

const InfoButton = () => {
  const { toggleModal } = useContext(InfoModalContext)

  return (
    <Button
      shape="round"
      className="info-btn"
      type="link"
      icon={<InfoIcon fill="currentColor" />}
      size="large"
      style={{ fontSize: '1rem', paddingLeft: 4, paddingRight: 4, alignItems: 'center' }}
      onClick={() => toggleModal(true)}
    >
      About this survey
    </Button>
  )
}

const Header = () => {
  const {
    push,
    location: {
      pathname: url
    }
  } = useHistory();

  const showInfoModalBtn = url === routes.QUIZ

  return (
    <div className="header-wrapper">
      <div className="header-desktop">
        <div className="logo" onClick={() => push(routes.HOME)} />
        {showInfoModalBtn && (
          <InfoButton />
        )}
        <NavTabs activeUrl={url} />
      </div>
      <div className="header-mobile">
        <div className="logo" />
        {showInfoModalBtn && (
          <InfoButton />
        )}
        <Dropdown overlay={<NavTabsOverlay url={url} />} trigger={[ 'click' ]}>
          <ThemedButton onClick={e => e.preventDefault()}><MenuOutlined /></ThemedButton>
        </Dropdown>
      </div>
    </div>
  )
};


export default Header;
